/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import FeedbackIcon from '@mui/icons-material/Feedback';

const feedbackButtonStyle = {
  color: 'common.white',
};

export default function Feedback() {
  return (
    <Tooltip title="Leave a feedback">
      <IconButton
        sx={feedbackButtonStyle}
        data-cy="feedback-button"
        component={Link}
        target="_blank"
        href="https://franz-projects.atlassian.net/servicedesk/customer/portals"
      >
        <FeedbackIcon />
      </IconButton>
    </Tooltip>
  );
}
